
import React from 'react';

const IRCDENTAL = () => {


    return (
        <>
            <div className="about-us-container">
                {/* Detailed Activities Section */}
                <section className="activities-details">
                    <button
                        onClick={() => window.history.back()}
                        style={{
                            marginBottom: '10px',
                            padding: '8px 10px',
                            backgroundColor: '#255fe8',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                            cursor: 'pointer',
                            fontSize: '16px',
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        ← Back to All Activities
                    </button>
                    <div className="activity-intro">
                        <h2>OUR ACTIVITIES</h2>
                        <p>All praise and thanks are due to Allaah Subhaanahu wa Ta'ala, IRC - Islamic Research Centre Education & Welfare Trust is involved in the following Social, Welfare and Charitable activities</p>
                    </div>

                    {/* IRC Dental Clinic */}
                    <div className="activity-card">
                        <div className="activity-header">
                            <h3>IRC DENTAL CLINIC (IDC)</h3>
                        </div>
                        <div className="activity-content">
                            <p>IRC Dental Clinic is a Reason to Smile Again! We are dedicated to providing top-notch dental care to everyone which includes a wide range of services like cleanings, fillings, root canals, and denture fittings. We prioritize preventive care and patient education, empowering individuals to take control of their oral health. With a team of skilled dentists, IRC Dental Clinic goes the extra mile by offering dental treatments at a very discounted rate and provides completely free medicines to everyone to ensure a healthier and brighter smile for every patient.</p>

                            <div className="clinic-card">
                                <h4>Clinic - 1 - Baijipura</h4>
                                <p><strong>Name:</strong> IRC Dental Clinic</p>
                                <p><strong>Address:</strong> IRC Community Centre, First Floor, Gali No. 34, Apex Hospital Road, Behind Sikandar Hall, Baijipura, Chhatrapati Sambhajinagar (Aurangabad) - 431003.</p>
                                <p>
                                    <strong>Location: </strong>
                                    <a href="https://www.google.com/maps/place/Apex+Superspeciality+Hospital/data=!4m7!3m6!1s0x3bdba298d50bd2af:0xc79047004783e9a6!8m2!3d19.8812498!4d75.3471543!16s%2Fg%2F11byp6kfwk!19sChIJr9IL1Zii2zsRpumDRwBHkMc?authuser=0&hl=en&rclk=1" target="_blank" rel="noopener noreferrer">
                                        📍Click here for Location
                                    </a>
                                </p>
                                <p><strong>Date of Inauguration:</strong> 08-Jun-2023</p>
                                <p><strong>No. of Patients Treated:</strong> 13,238 (till 31-Jan-2025)</p>
                                <p><strong>Contact No:</strong> 9607-9607-67</p>
                            </div>

                            <div className="clinic-card">
                                <h4>Clinic - 2 - Kiradpura</h4>
                                <p><strong>Name:</strong> IRC Dental Clinic</p>
                                <p><strong>Address:</strong> Shop No 3, SK Tower, Plot No 1, Zone No 3, Jaswantpura, Kiradpura, Chhatrapati Sambhajinagar (Aurangabad) - 431001</p>
                                <p>
                                    <strong>Location: </strong>
                                    <a href="https://www.google.com/maps/place/Apex+Superspeciality+Hospital/data=!4m7!3m6!1s0x3bdba298d50bd2af:0xc79047004783e9a6!8m2!3d19.8812498!4d75.3471543!16s%2Fg%2F11byp6kfwk!19sChIJr9IL1Zii2zsRpumDRwBHkMc?authuser=0&hl=en&rclk=1" target="_blank" rel="noopener noreferrer">
                                        📍Click here for Location
                                    </a>
                                </p>
                                <p><strong>Date of Inauguration:</strong> 18-Sep-2024</p>
                                <p><strong>No. of Patients Treated:</strong> 2,179 (till 31-Jan-2025)</p>
                                <p><strong>Contact No:</strong> 8507-8507-32</p>
                            </div>

                            <div className="clinic-card">
                                <h4>Clinic - 3 - Buddi Lane</h4>
                                <p><strong>Name:</strong> IRC Dental Clinic</p>
                                <p><strong>Address:</strong> H.No 1-13-37, Near Nehru Bhawan, Fatima Maternity Hospital Road, Buddi Lane, Chhatrapati Sambhajinagar (Aurangabad) - 431001</p>
                                <p>
                                    <strong>Location: </strong>
                                    <a href="https://www.google.com/maps/place/Apex+Superspeciality+Hospital/data=!4m7!3m6!1s0x3bdba298d50bd2af:0xc79047004783e9a6!8m2!3d19.8812498!4d75.3471543!16s%2Fg%2F11byp6kfwk!19sChIJr9IL1Zii2zsRpumDRwBHkMc?authuser=0&hl=en&rclk=1" target="_blank" rel="noopener noreferrer">
                                        📍Click here for Location
                                    </a>
                                </p>
                                <p><strong>Date of Inauguration:</strong> NA</p>
                                <p><strong>No. of Patients Treated:</strong> NA</p>
                                <p><strong>Contact No:</strong> 7537-9999-22</p>
                            </div>
                        </div>
                    </div>

                </section>
            </div>
        </>
    );
};

export default IRCDENTAL;